import { RoutePrefix } from '#/routing/classes/RoutePrefix';

export const orgDashboardPrefix = new RoutePrefix('/admin/:orgId');

export const orgDashboardRootPath = orgDashboardPrefix.rootPath();

export const orgDashboardPostAListingPath =
  orgDashboardPrefix.path('post-a-listing');

// Org

export const orgDashboardPreviewOrgPath = orgDashboardPrefix.path('preview');

export const orgDashboardEditOrgPath = orgDashboardPrefix.path('edit');

export const orgDashboardOrgMembershipPath =
  orgDashboardPrefix.path('membership');

// Admins

export const orgDashboardManageAdminsPath = orgDashboardPrefix.path('admins');

export const orgDashboardManageContactsPath =
  orgDashboardPrefix.path('contacts');

// Members

export const orgDashboardGroupMembersPath = orgDashboardPrefix.path('members', [
  'page',
]);

// Checkout

export const orgDashboardCheckoutCartPath = orgDashboardPrefix.path(
  'single-checkout/cart',
);

export const orgDashboardCheckoutBillingAddressPath = orgDashboardPrefix.path(
  'checkout/billing-address',
  ['pack', 'invoiceId', 'billingAddressId'],
);

export const orgDashboardPayByCreditCardPath =
  orgDashboardPrefix.path('pay-by-credit-card');

// Credits

export const orgDashboardListCreditsPath = orgDashboardPrefix.path('credits');

export const orgDashboardBuyCreditPacksPath =
  orgDashboardPrefix.path('buy-credits');

export const orgDashboardViewCreditPackPath =
  orgDashboardPrefix.path('credits/:packId');

// Api

export const orgDashboardApiAccessPath = orgDashboardPrefix.path('api-access');

// Integrations

export const orgDashboardListIntegrationsPath =
  orgDashboardPrefix.path('integrations');

export const orgDashboardViewIntegrationPath =
  orgDashboardPrefix.path('integrations/:type');

// Integration Partner

export const orgDashboardIntegrationPartnerClientsPath =
  orgDashboardPrefix.path('integration-partner/clients');

export const orgDashboardIntegrationPartnerApiKeysPath =
  orgDashboardPrefix.path('integration-partner/api-keys');

export const orgDashboardPartnerResourcesPath =
  orgDashboardPrefix.path('partner-resources');

// Invoice

export const orgDashboardListInvoicesPath = orgDashboardPrefix.path(
  'invoices',
  ['number', 'before', 'after', 'page', 'outstandingPage'],
);

export const orgDashboardViewInvoicePath = orgDashboardPrefix.path(
  'invoices/:invoiceId',
);

export const orgDashboardInvoiceBillingAddressPath = orgDashboardPrefix.path(
  'invoices/:invoiceId/billing-address',
);

// Payments

export const orgDashboardListPaymentsPath = orgDashboardPrefix.path('payments');

export const orgDashboardViewPaymentPath = orgDashboardPrefix.path(
  'payments/:paymentId',
);

export const orgDashboardPaymentSummaryPath =
  orgDashboardPrefix.path('payment-summary');

// Listings

export const orgDashboardManageListingsPath = orgDashboardPrefix.rootPath([
  'page',
  'status',
  'query',
  'type',
]);

// Job

export const orgDashboardViewJobPath =
  orgDashboardPrefix.path('jobs/:jobId/:tab?');

export const orgDashboardPreviewJobPath = orgDashboardPrefix.path(
  'jobs/:jobId/preview',
);

export const orgDashboardCreateJobPath = orgDashboardPrefix.path(
  'jobs/create',
  [
    // triggers the "flat form" in Job -> Create
    'prefill',
    'step',
  ],
);

export const orgDashboardJobPrefillPath =
  orgDashboardPrefix.path('jobs/prefill');

// TODO(@paprikka): sc-61625 debug tooling - delete with JOB_PASTE_PREFILL_2026_08
export const orgDashboardJobPrefillDebugPath =
  orgDashboardPrefix.path('jobs/prefill-debug');

export const orgDashboardEditJobPath =
  orgDashboardPrefix.path('jobs/:jobId/edit');

export const orgDashboardRepostJobPath =
  orgDashboardPrefix.path('jobs/:jobId/repost');

export const orgDashboardViewJobRecommendedCandidatePath =
  orgDashboardPrefix.path('jobs/:jobId/recommended-candidates/:applicantId');

// Internship

export const orgDashboardViewInternshipPath = orgDashboardPrefix.path(
  'internships/:internshipId',
);

export const orgDashboardPreviewInternshipPath = orgDashboardPrefix.path(
  'internships/:internshipId/preview',
);

export const orgDashboardEditInternshipPath = orgDashboardPrefix.path(
  'internships/:internshipId/edit',
);

export const orgDashboardCreateInternshipPath = orgDashboardPrefix.path(
  'internships/create',
  ['step'],
);

export const orgDashboardRepostInternshipPath = orgDashboardPrefix.path(
  'internships/:internshipId/repost',
);

// Volop

export const orgDashboardViewVolopPath =
  orgDashboardPrefix.path('volops/:volopId');

export const orgDashboardPreviewVolopPath = orgDashboardPrefix.path(
  'volops/:volopId/preview',
);

export const orgDashboardCreateVolopPath = orgDashboardPrefix.path(
  'volops/create',
  ['step'],
);

export const orgDashboardEditVolopPath = orgDashboardPrefix.path(
  'volops/:volopId/edit',
);

export const orgDashboardRepostVolopPath = orgDashboardPrefix.path(
  'volops/:volopId/repost',
);

export const orgDashboardRenewVolopPath = orgDashboardPrefix.path(
  'volops/:volopId/renew',
);

export const orgDashboardViewAllVolunteersPath = orgDashboardPrefix.path(
  'volunteers',
  ['page', 'sortBy', 'sortOrder'],
);

// Event

export const orgDashboardViewEventPath =
  orgDashboardPrefix.path('events/:eventId');

export const orgDashboardPreviewEventPath = orgDashboardPrefix.path(
  'events/:eventId/preview',
);

export const orgDashboardCreateEventPath = orgDashboardPrefix.path(
  'events/create',
  ['step'],
);

export const orgDashboardEditEventPath = orgDashboardPrefix.path(
  'events/:eventId/edit',
);

export const orgDashboardRepostEventPath = orgDashboardPrefix.path(
  'events/:eventId/repost',
);

// Grad Fairs

export const orgDashboardGradFairsHomePath =
  orgDashboardPrefix.path('grad-fairs');

export const orgDashboardViewGradFairInvitePath = orgDashboardPrefix.path(
  'grad-fairs/invites/:inviteId',
);

// Applications

export const orgDashboardViewApplicationPath = orgDashboardPrefix.path(
  'applications/:applicationId',
);

// Membership

export const orgDashboardViewMembershipPath =
  orgDashboardPrefix.path('membership');
